// extracted by mini-css-extract-plugin
module.exports = {"axis":"graph__axis___QcLSb","hidden":"graph__hidden___3W5vy"};